import React from 'react';
import { useTranslation } from 'react-i18next';
import { Block, CrossIcon, FlexRow, IconButton, MyEmailIcon, SmallText } from '@guryou/html-components';
import { borderDefinition, smallBorderRadius } from '@guryou/html-theme';

const EmailNotVerified = ({ onClose }) => {
  const { t } = useTranslation();

  return (
    <FlexRow
      margin={0}
      marginTop={1}
      minHeight={50}
      alignItems="center"
      backgroundColor="#E0F7FA"
      xs={12}
      border={borderDefinition('#4DD0E1', '2px')}
      borderRadius={smallBorderRadius}
    >
      <FlexRow alignItems="center" justifyContent="space-between" paddingLeft={2} margin={0}>
        <FlexRow xs={12} alignItems="center" margin={0}>
          <Block xs={1.2} margin={0} display="flex" alignItems="center">
            <MyEmailIcon htmlColor="#4DD0E1" />
          </Block>
          <SmallText xs={9.4} fontSize="0.9rem" fontWeight="800" color="#006064" textAlign="center">
            {t('ONBOARD.verifyMessage')}
          </SmallText>
          <Block xs={1.4} margin={0} display="flex" alignItems="center" justifyContent="end" paddingRight={2}>
            <IconButton icon={CrossIcon} onClick={() => onClose()} size="small" />
          </Block>
        </FlexRow>
      </FlexRow>
    </FlexRow>
  );
};

export default EmailNotVerified;
